import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { PromoPartnerFamily } from 'src/app/assabil-sales/models/entities/promo-partner-family.entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
  selector: 'promo-partner-family-list',
  templateUrl: './promo-partner-family-list.component.html',
  styleUrls: ['./promo-partner-family-list.component.scss']
})

export class PromoPartnerFamilyListComponent extends BasePage2<PromoPartnerFamily> {

  promoPartnerFamilies  : PromoPartnerFamily[] = [];
  codeFilter            : string;
  nameFilter            : string;
 


  constructor(protected toastr  : ToastrService,
    protected router            : Router,
    protected promoService      : PromoService,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService,
    protected location          : Location) {
   
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'promoPartnerFamily';
  }



  initEntityContainer() {
  }

  selectRow(promoPartnerFamily : PromoPartnerFamily){
    this.promoService.promoPartnerFamilyGet(promoPartnerFamily.promoPartnerFamilyCode).then(promoPartnerFamily => {
      this.selectedRow = promoPartnerFamily;
    });
  }

  getRows(): PromoPartnerFamily[] {
      return this.promoPartnerFamilies;
  }

  saveRow(row: PromoPartnerFamily): Promise<PromoPartnerFamily> {
     // return this.promoService.promoPartnerFamilySave(row);
     throw new Error("Method not implemented.");
  }


  loadData(){
    this.promoService.promoPartnerFamiliesGet(this.codeFilter, this.nameFilter).then(promoPartnerFamilies => {
      this.promoPartnerFamilies = promoPartnerFamilies;
    });
  }

  newPromoPartnerFamily(){
    let promoPartnerFamily = new PromoPartnerFamily();
    promoPartnerFamily.inserted = true;
    promoPartnerFamily.edit     = true;
    this.selectedRow = promoPartnerFamily;
  }

}
